var _logoUploadUrlQuery;

import { graphql } from 'react-relay';
export const logoUploadUrlQuery = _logoUploadUrlQuery !== void 0 ? _logoUploadUrlQuery : _logoUploadUrlQuery = require("./__generated__/logoUploadUrlQuery.graphql");